/**
 * The preferences that are referenced in this file are available in window.PREFERENCES object.
 * window.PREFERENCES has key-value pairs where:
 * - the key is the same as a certain feature flag (e.g. for ECG it is 5c8d3401-e6e7-4354-9095-39526016a47c)
 * - the value is the user role that feature flag depends on (e.g. ROLE_SAMD_TESTER)
 */

export const restrictedPropertyFiles = {
    // '/featureFile/featureFile': 'featureRoleKey'
    '/ecg/ecg': '5c8d3401-e6e7-4354-9095-39526016a47c',
    '/sleep_skin_temp/sleep_skin_temp': 'd3c94498-8962-4a62-bd3a-0d80a08e3386',
    '/sleep_navigation/sleep_navigation': '7ae52c9a-1967-46e9-952f-3e40e3770bde',
    '/trails/trails': 'fcc01c82-c905-4e77-99f4-b42c163d391a',
    '/mct_skin_temp/mct_skin_temp': '79187c9a-90db-47c8-a3b3-523c8e2e3e94',
    '/breathing_variations/breathing_variations': 'e2ea4982-7bb1-473a-ae81-8daf86b69860',
    '/gcp/gcp': 'c4580beb-d4fd-4fe4-8abf-3138b01ee17f',
    '/userframe/userframe': '40875613-7332-4180-88ba-acc0be345e53',
    '/performance_dashboard/performance_dashboard': 'e02fc029-7d8e-41ae-a9dd-a9dc491b51f8'
};

export const shouldRestrictByRole = (restrictedRoleKey, userRoles) => {
    if (restrictedRoleKey && window.PREFERENCES) {
        const userRolesToRestrictTo = window.PREFERENCES[restrictedRoleKey].split(',');
        if (
            userRolesToRestrictTo &&
            userRoles &&
            userRolesToRestrictTo.some((role) => userRoles.indexOf(role.trim()) >= 0)
        ) {
            return false;
        } else {
            return true;
        }
    }

    return false;
};
